import { Component } from 'react';

import StripeForm from './stripeform.jsx';

export default class PaymentForm extends Component {
  render() {
    let className = '';
    if (!this.props.active && this.state.complete) {
      className += ' support-section-complete';
    }

    return (
      <div className={`payment-form ${className}`}>
        <div className="clearfix payment-form-header">
          <h2 className="payment-form-title">Payment</h2>
        </div>
        {this.props.active && this.renderActive()}
        {!this.props.active && this.state.complete && this.renderComplete()}
      </div>
    );
  }

  renderActive() {
    return (
      <div>
        <StripeForm
          onComplete={this.props.onComplete}
          contactInfo={this.props.contactInfo}
          amount={this.props.amount}
          frequency={this.props.frequency}
          coverFees={this.props.coverFees}
        />
      </div>
    );
  }

  renderComplete() {
    const card = this.props.savedPaymentToken.card;
    return `${card.brand} ending in ${card.last4}`;
  }
}
